import React, { useState, useEffect } from "react";
import { Button } from "@/components/ui/button";
import { Sheet, SheetContent, SheetTrigger } from "@/components/ui/sheet";
import { Menu } from "lucide-react";
import { Link } from "react-router-dom";
import { isBrowser } from "@/utils/runtime";

const TocFotosHeader = () => {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    if (!isBrowser) return;
    const handleScroll = () => {
      if (globalThis.scrollY > 50) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    globalThis.addEventListener("scroll", handleScroll, {
      passive: true
    });
    return () => globalThis.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToSection = (sectionId: string) => {
    if (isBrowser) {
      const section = globalThis.document.getElementById(sectionId);
      if (section) {
        section.scrollIntoView({
          behavior: "smooth"
        });
      }
    }
  };

  return (
    <header className={`py-4 bg-white sticky top-0 z-50 transition-all duration-300 ${isScrolled ? "shadow-md py-2" : "shadow-sm"}`}>
      <div className="container max-w-7xl mx-auto px-4 flex justify-between items-center">
        <div className="flex items-center">
          <Link to="/tocfotos01" className="flex items-center space-x-2">
            <img 
              src="/lovable-uploads/24e0e29e-3e10-43db-8be9-1cc4bc18ab2f.png" 
              alt="TocToc Logo" 
              loading="eager"
              width="114"
              height="64"
              className="h-8"
              decoding="async"
            />
          </Link>
        </div>
        <nav className="hidden md:flex space-x-8 items-center">
          <button onClick={() => scrollToSection("como-funciona")} className="text-toctoc-gray-dark hover:text-[#FF5605] font-medium transition-colors">
            Como funciona
          </button>
          <button onClick={() => scrollToSection("galeria")} className="text-toctoc-gray-dark hover:text-[#FF5605] font-medium transition-colors">
            Galeria
          </button>
          <button onClick={() => scrollToSection("depoimentos")} className="text-toctoc-gray-dark hover:text-[#FF5605] font-medium transition-colors">
            Depoimentos
          </button>
          <button onClick={() => scrollToSection("contato")} className="text-toctoc-gray-dark hover:text-[#FF5605] font-medium transition-colors">
            Contato
          </button>
          <Link to="/admin-login" className="text-toctoc-gray-dark hover:text-[#FF5605] font-medium transition-colors">
            Login
          </Link>
          <Button variant="default" className="bg-[#FF5605] hover:bg-[#E14D04] text-white rounded-full" onClick={() => scrollToSection("contato")}>
            Solicitar Orçamento
          </Button>
        </nav>
        <Sheet>
          <SheetTrigger asChild>
            <Button variant="ghost" className="md:hidden">
              <Menu className="h-6 w-6" />
            </Button>
          </SheetTrigger>
          <SheetContent side="right">
            <div className="flex flex-col gap-4 mt-8">
              <button onClick={() => {
              scrollToSection("como-funciona");
              globalThis.document.querySelector("[data-radix-scroll-area-viewport]")?.parentElement?.click();
            }} className="text-lg text-toctoc-gray-dark hover:text-[#FF5605] font-medium transition-colors text-left">
                Como funciona
              </button>
              <button onClick={() => {
              scrollToSection("galeria");
              globalThis.document.querySelector("[data-radix-scroll-area-viewport]")?.parentElement?.click();
            }} className="text-lg text-toctoc-gray-dark hover:text-[#FF5605] font-medium transition-colors text-left">
                Galeria
              </button>
              <button onClick={() => {
              scrollToSection("depoimentos");
              globalThis.document.querySelector("[data-radix-scroll-area-viewport]")?.parentElement?.click();
            }} className="text-lg text-toctoc-gray-dark hover:text-[#FF5605] font-medium transition-colors text-left">
                Depoimentos
              </button>
              <button onClick={() => {
              scrollToSection("contato");
              globalThis.document.querySelector("[data-radix-scroll-area-viewport]")?.parentElement?.click();
            }} className="text-lg text-toctoc-gray-dark hover:text-[#FF5605] font-medium transition-colors text-left">
                Contato
              </button>
              <Link
                to="/admin-login"
                onClick={() => {
                  globalThis.document.querySelector("[data-radix-scroll-area-viewport]")?.parentElement?.click();
                }}
                className="text-lg text-toctoc-gray-dark hover:text-[#FF5605] font-medium transition-colors text-left"
              >
                Login
              </Link>
              <Button className="w-full mt-4 bg-[#FF5605] hover:bg-[#E14D04] text-white rounded-full" onClick={() => {
              scrollToSection("contato");
              globalThis.document.querySelector("[data-radix-scroll-area-viewport]")?.parentElement?.click();
            }}>
                Solicitar Orçamento
              </Button>
            </div>
          </SheetContent>
        </Sheet>
      </div>
    </header>
  );
};

export default TocFotosHeader;
